import { render, staticRenderFns } from "./AccountTransfer.vue?vue&type=template&id=197a01eb&scoped=true"
import script from "./AccountTransfer.vue?vue&type=script&lang=js"
export * from "./AccountTransfer.vue?vue&type=script&lang=js"
import style0 from "./AccountTransfer.vue?vue&type=style&index=0&id=197a01eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197a01eb",
  null
  
)

export default component.exports